import { UserInfoBase, UserInfoAccount, UserInfoCancel } from '_c/typings/proto';

export interface State {
  baseInfo: UserInfoBase | undefined;
  accountInfo: UserInfoAccount | undefined;
  cancelInfo: UserInfoCancel | undefined;
}

export interface IloginInfo {
  baseInfo: State['baseInfo'];
  accountInfo: State['accountInfo'];
  cancelInfo: State['cancelInfo'];
}

const state: State = {
  baseInfo: undefined,
  accountInfo: undefined,
  cancelInfo: undefined,
};

const userInfoStorage = localStorage.getItem('login-user-info');
if (userInfoStorage) {
  try {
    const userInfo = JSON.parse(userInfoStorage) as IloginInfo;
    state.baseInfo = userInfo.baseInfo;
    state.accountInfo = userInfo.accountInfo;
    state.cancelInfo = userInfo.cancelInfo;
  } catch (e) {
    // nothing to do
  }
}

export default state;
